import { getAuthState } from '@sxm-de/dev-kits/web-sdk/utils';

export type IsAnonymousFn = () => boolean;

export function initIsAnonymousFn(): IsAnonymousFn {
    return () => {
        return getAuthState() === 'anonymous';
    };
}
